export default class {
    constructor() {
        this.listen();
    }

    listen() {
        const orderModal = document.getElementById('modalOrder');
        let boardWidthInputs = document.querySelectorAll('.js_board-width input');

        orderModal.addEventListener('show.bs.modal', function (event) {
            let button = event.relatedTarget;            
            let modalTitle = orderModal.querySelector('.modal-title');
            
            if (button.hasAttribute('data-bs-whatever')) {
                let recipient = button.getAttribute('data-bs-whatever');
                modalTitle.textContent = 'Заказ имитации бруса ' + recipient + ' мм';

                boardWidthInputs.forEach(input => {
                    const value = input.value;
                    input.removeAttribute('checked');
                    if (recipient === value) {
                        input.setAttribute('checked', true);
                    }
                })
            } else {
                modalTitle.textContent = 'Заказ имитации бруса';
                boardWidthInputs[0].setAttribute('checked', true);
            }
        })
    }
}